// extracted by mini-css-extract-plugin
export default {"select":"antdDropdown_select__X+IjQ","label_style":"antdDropdown_label_style__DXoV1"};